import { RoutesCalculationServiceInterface } from './interfaces';
import { RoutesCalculationService } from './RoutesCalculationService';

// Фабрика сервиса
export const routesCalculationService: {
  (token?: string): RoutesCalculationServiceInterface;
} = (token) => new RoutesCalculationService(token);
